<template>
  <div class="publish" style="position:relative;">
    <div class="contentbox">
      <div class="content">
        <div class="topbox">
          <div class="introduction">
            <p class="txt1">{{ $t('EcologicalCenter.introduction.txt_1') }}</p>
            <p class="txt1_1">{{ $t('EcologicalCenter.introduction.txt_1_1') }}</p>
            <p class="txt2">{{ $t('EcologicalCenter.introduction.txt_2') }}</p>
            <a href="#publish#getStarted" class="b-btn">{{ $t('EcologicalCenter.introduction.btn') }}</a>
            <!-- <p class="txt3">{{$t('EcologicalCenter.introduction.txt_3')}}
              <a target="_blank"
                href="https://cloudpartner.azure.cn/zh-cn">{{$t('EcologicalCenter.introduction.toPartner')}}</a>
            </p> -->
          </div><!-- introduction结束 -->

          <div class="features">
            <el-row>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <div class="channel textContent">
                  <p class="txt1">{{ $t('EcologicalCenter.features.channel_1') }}</p>
                  <p class="txt2">{{ $t('EcologicalCenter.features.channel_2') }}</p>
                </div>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <div class="deliver textContent">
                  <p class="txt1">{{ $t('EcologicalCenter.features.deliver_1') }} </p>
                  <p class="txt2">{{ $t('EcologicalCenter.features.deliver_2') }} </p>
                </div>
              </el-col>
              <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                <div class="value textContent">
                  <p class="txt1">{{ $t('EcologicalCenter.features.value_1') }} </p>
                  <p class="txt2">{{ $t('EcologicalCenter.features.value_2') }}</p>
                </div>
              </el-col>
            </el-row>
          </div><!-- features结束 -->
        </div><!-- topbox结束 -->
        <a name="publish#getStarted"></a>
        <div class="mainbox">
          <h1>{{ $t('EcologicalCenter.maintxt.start') }}</h1>
          <div class="maincontent">
            <el-row :gutter="60" type="flex" justify="center">
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <div class="publish item">
                  <img src="../../assets/image/publish.png">
                  <p class="txt1">{{ $t('EcologicalCenter.maintxt.publish_1') }}</p>
                  <p class="txt2">{{ $t('EcologicalCenter.maintxt.publish_2') }}</p>
                  <a :href="href" target="_blank"
                    class="as-btn">{{ $t('EcologicalCenter.maintxt.publish_btn') }}</a>
                  <p style="clear:both"></p>
                </div>
              </el-col>
              <!-- <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <div class="sales item">
                  <img src="../../assets/image/sales.png">
                  <p class="txt1">{{$t('EcologicalCenter.maintxt.sales_1')}}</p>
                  <p class="txt2">{{$t('EcologicalCenter.maintxt.sales_2')}}</p>
                  <a href="https://docs.azure.cn/zh-cn/articles/azure-marketplace/businessbi" target="_blank"
                    class="as-btn">{{$t('EcologicalCenter.maintxt.sales_btn')}}</a>
                  <p style="clear:both"></p>
                </div>
              </el-col> -->
            </el-row>
          </div>
        </div><!-- mainbox结束 -->
        <div class="application hidden-sm-and-down">
          <p class="txt1">{{ $t('EcologicalCenter.application.appli_1') }}</p>
          <p class="txt2">{{ $t('EcologicalCenter.application.appli_2') }}</p>
          <div class="b-btn" @click="toRegister">{{ $t('EcologicalCenter.application.appli_btn') }}</div>
        </div><!-- application结束 -->
        <div class="application hidden-sm-and-up">
          <p class="txt1" style="font-size:20px;">{{ $t('EcologicalCenter.application.appli_1') }}</p>
          <p class="txt2">{{ $t('EcologicalCenter.application.appli_2') }}</p>
          <div class="b-btn" @click="toRegister">{{ $t('EcologicalCenter.application.appli_btn') }}</div>
        </div><!-- application结束 -->
      </div><!-- content结束 -->
    </div><!-- contentbox结束 -->
  </div>
</template>

<script>

export default {
  methods: {
    toRegister() {
      this.$router.push({
        name: 'Register', params: {
          lang: sessionStorage.lang == 'en' ? 'en-us' : 'zh-cn'
        }
      })
    }
  },
  computed: {
    href() {
      return ` https://docs.azure.cn/${this.$store.state.language === 1 ? 'en-us' : 'zh-cn'}/partner-center/marketplace/publisher-guide-by-offer-type`
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped src="../../assets/css/EcologicalCenter.scss"></style>
